module.exports = __webpack_public_path__ + "static/img/due.70787ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/due.png
// module id = TA/P
// module chunks = 1